import * as R from 'ramda';
import axios from 'axios';
import React, {Component} from 'react';

import {MAPS} from 'js/common';

// Components
import HeartRating from 'js/components/heart_rating';

import 'scss/rate_creators.scss';

function formatAvgRating(x) {
    if (x === Math.round(x)) {
        return x.toFixed(0);
    }
    return x.toFixed(1);
}

class RateCreator extends Component {
    constructor(props) {
        super(props);

        const creator = this.props.posts[0];

        this.state = {
            creator,
            rating: creator.creator_rating,
            showFeedback: false,
            ratingId: null
        };
    }

    handleRating = (e, rating) => {
        e.preventDefault();
        e.stopPropagation();

        axios.post(this.props.rateCreatorUrl, {rating}).then(response => {
            this.setState({
                ratingId: response.data.rating_id,
                showFeedback: true,
                rating
            });
        });
    };

    handleFeedback = () => {
        this.setState({
            showFeedback: false
        });

        const feedback = this.refs.feedback.value;

        if (R.isEmpty(feedback)) {
            return;
        }

        const {ratingId} = this.state;
        const url = this.props.commentOnCreatorUrl.replace('__RATING_ID__', ratingId);

        axios.post(url, {
            rating_id: ratingId,
            comment: this.refs.feedback.value
        });
    };

    renderBioOrFeedbackForm = () => {
        const {
            showFeedback,
            creator: {username}
        } = this.state;

        if (showFeedback) {
            return (
                <div className="rate-creator-feedback">
                    <div>Thanks for scoring this creator! Why did you select this rating?</div>
                    <input type="text" ref="feedback" />
                    <button className="btn btn-primary" onClick={this.handleFeedback}>
                        Submit
                    </button>
                </div>
            );
        }
        return (
            <div>
                <a
                    href={`https://instagram.com/${username}`}
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    <div>{username}</div>
                </a>
            </div>
        );
    };

    renderCampaignPost = post => {
        const {thumbnail_url} = post;

        return (
            <a key={thumbnail_url} href={thumbnail_url} target="_blank" rel="noopener noreferrer">
                <img
                    src={thumbnail_url}
                    className="rate-creator-recent-post rate-creator-campaign-post"
                />
            </a>
        );
    };

    renderRecentPost = post => {
        const {image_url} = post;

        return (
            <a key={image_url} href={image_url}>
                <img src={image_url} className="rate-creator-recent-post" />
            </a>
        );
    };

    render() {
        const {posts} = this.props;
        const {
            rating,
            creator: {avg_creator_score, username, profile_image_url, recent_media}
        } = this.state;

        const heartStyle = {
            color: 'red'
        };

        return (
            <div key={username} className="rate-creator">
                <div className="rate-creator-hearts">
                    <div>
                        <HeartRating
                            heartCount={R.length(R.keys(MAPS.CreatorScoreDescription))}
                            heartsFilled={rating}
                            clickScore={this.handleRating}
                            heartStyle={heartStyle}
                            tooltips={MAPS.CreatorScoreDescription}
                        />
                    </div>
                    <div className="rate-creator-avg">
                        {avg_creator_score ? `Avg. ${formatAvgRating(avg_creator_score)}` : null}
                    </div>
                </div>
                <div>
                    <a
                        href={`https://instagram.com/${username}`}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <img src={profile_image_url} className="rate-creator-profile-picture" />
                    </a>
                </div>
                <div className="rate-creator-info">{this.renderBioOrFeedbackForm()}</div>
                <div className="rate-creator-posts">
                    {R.pipe(
                        R.take(6),
                        R.map(this.renderCampaignPost)
                    )(posts)}
                    {R.pipe(
                        R.take(R.max(0, 6 - posts.length)),
                        R.map(this.renderRecentPost)
                    )(recent_media || [])}
                </div>
            </div>
        );
    }
}

export default class RateCreatorsList extends Component {
    renderRow = posts => {
        const {campaignId} = this.props;
        const {lead_id} = posts[0];
        const rateCreatorUrl = this.props.rateCreatorUrl
            .replace('__CAMPAIGN_ID__', campaignId)
            .replace('__LEAD_ID__', lead_id);
        const commentOnCreatorUrl = this.props.commentOnCreatorUrl
            .replace('__CAMPAIGN_ID__', campaignId)
            .replace('__LEAD_ID__', lead_id);
        return (
            <RateCreator
                posts={posts}
                rateCreatorUrl={rateCreatorUrl}
                commentOnCreatorUrl={commentOnCreatorUrl}
            />
        );
    };

    render() {
        const {posts} = this.props;
        const creators = R.pipe(
            R.groupBy(R.prop('username')),
            R.values,
            R.sortBy(posts => posts[0].username)
        )(posts);

        if (R.isEmpty(posts)) {
            return <div>No creators to rate.</div>;
        }
        return (
            <div>
                <div className="rate-creators-heading">Rate your creators</div>

                <div className="rate-creators">{R.map(this.renderRow, creators)}</div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./campaign_analytics/v2/campaign_analytics_page/posts/rate_creators.js